import { render, staticRenderFns } from "./UserAccountDetail.vue?vue&type=template&id=2d2b9da9&scoped=true"
import script from "./UserAccountDetail.vue?vue&type=script&lang=js"
export * from "./UserAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./UserAccountDetail.vue?vue&type=style&index=0&id=2d2b9da9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b9da9",
  null
  
)

export default component.exports